import { FileText, Brain, BookOpen, FlaskConical, Spade, Trophy } from 'lucide-react';

export const PLANNER_TYPES = {
  presentacion: { icon: FileText, label: 'Presentación', cls: 'bg-blue-50 text-blue-700 border-blue-200' },
  cuestionario: { icon: Brain, label: 'Cuestionario', cls: 'bg-emerald-50 text-emerald-700 border-emerald-200' },
  masterclass: { icon: BookOpen, label: 'Masterclass', cls: 'bg-white text-black border-gray-300' },
  escape_room: { icon: FlaskConical, label: 'Escape Room', cls: 'bg-amber-50 text-amber-700 border-amber-200' },
  card_game: { icon: Spade, label: 'Juego de Cartas', cls: 'bg-purple-50 text-purple-700 border-purple-200' },
  simulacro: { icon: Trophy, label: 'Simulacro', cls: 'bg-red-50 text-red-700 border-red-200' },
};
export const plannerKey = item => `${item.type}:${item.id}`;
export const plannerError = error => typeof error.response?.data?.detail === 'string'
  ? error.response.data.detail : 'No se pudo completar la acción. Intenta nuevamente.';